export const throwError = message => console.error(`REINOS_MAPS: ${message}`)
